/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PopularCategoriesAndSubCategories
 */
export interface PopularCategoriesAndSubCategories {
    /**
     * 
     * @type {boolean}
     * @memberof PopularCategoriesAndSubCategories
     */
    categoryOrSubcategory?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PopularCategoriesAndSubCategories
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PopularCategoriesAndSubCategories
     */
    count?: number;
}

export function PopularCategoriesAndSubCategoriesFromJSON(json: any): PopularCategoriesAndSubCategories {
    return PopularCategoriesAndSubCategoriesFromJSONTyped(json, false);
}

export function PopularCategoriesAndSubCategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PopularCategoriesAndSubCategories {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryOrSubcategory': !exists(json, 'categoryOrSubcategory') ? undefined : json['categoryOrSubcategory'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function PopularCategoriesAndSubCategoriesToJSON(value?: PopularCategoriesAndSubCategories | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categoryOrSubcategory': value.categoryOrSubcategory,
        'id': value.id,
        'count': value.count,
    };
}

